<label class="search-wrapper" [for]="id" [ngClass]="{disabled: disabled, 'clear-btn-visible': value}">
    <i class="fa fa-search" *ngIf="!loading"></i>
    <input
        type="search"
        autocomplete="off"
        #searchInputEl
        class="search-input"
        [autoFocus]="enableAutoFocus"
        [id]="id"
        [placeholder]="placeholder"
        [required]="required"
        [disabled]="disabled"
        [attr.maxlength]="maxLength"
        [attr.minlength]="minLength"
        [value]="value"
        (blur)="invokeTouchCallback()"
        (input)="onChange()"
        (click)="$event.stopPropagation()"
    />
    <button type="button" class="clear-btn" *ngIf="value && !loading" (click)="onClear($event)"></button>
    <i class="fa fa-spinner spinner" *ngIf="modern && loading"></i>
</label>
